import axios from "axios";
import Config from "../../Config";

export const loginUser = async (credentials) => {
  try {
    const response = await axios.post(
     
      `${Config.baseUrl}/login`,
      credentials
    );
     console.log(response);

    if (response.data.data.status_code === "000") {
      localStorage.setItem("auth_token", response.data.data.data.token);
      localStorage.setItem("user_data", JSON.stringify(response.data.data.data));
      
      axios.defaults.headers.common["Authorization"] = `Bearer ${response.data.data.data.token}`;
      
      return response.data.data.data;
    } else {
      throw new Error(response.data.data.reason || "Login failed");
    }
  } catch (error) {
    throw new Error(error.response?.data?.data?.reason || "Login failed");
  }
};

export const requestPasswordReset = async (emailData) => {
  try {
    const response = await axios.post(
      `${Config.baseUrl}/email/resetpassword`,
      { emailOrPhone: emailData.email }
    );

    if (response.data.data.status_code === "000") {
      localStorage.setItem("reset_user_data", JSON.stringify(response.data.data.data));
      return response.data.data;
    } else {
      throw new Error(response.data.data.reason || "Password reset request failed");
    }
  } catch (error) {
    throw new Error(error.response?.data?.data?.reason || "Password reset request failed");
  }
};

export const resetPassword = async (resetData) => {
  try {
    const response = await axios.post(
      `${Config.baseUrl}/resetpassword`,
      {
        password: resetData.password,
        admin_slug: JSON.parse(localStorage.getItem("reset_user_data"))?.admin_slug,
        otp: parseInt(resetData.otp)
      }
    );

    if (response.data.data.status_code === "000") {
      localStorage.removeItem("reset_user_data");
      return response.data.data;
    } else {
      throw new Error(response.data.data.reason || "Password reset failed");
    }
  } catch (error) {
    throw new Error(error.response?.data?.data?.reason || "Password reset failed");
  }
};

export const resendOTP = async (emailData) => {
  try {
    const response = await axios.post(
      `${Config.baseUrl}/email/resetpassword`,
      { emailOrPhone: emailData.email }
    );

    if (response.data.data.status_code === "000") {
      return response.data.data;
    } else {
      throw new Error(response.data.data.reason || "Failed to resend OTP");
    }
  } catch (error) {
    throw new Error(error.response?.data?.data?.reason || "Failed to resend OTP");
  }
};

export const logoutUser = () => {
  try {
    localStorage.clear();
    sessionStorage.clear();    
    delete axios.defaults.headers.common["Authorization"];    
    window.location.href = "/signin";
    return true;
  } catch (error) {
    console.error("Logout error:", error);
    throw new Error("Failed to logout");
  }
};

//Todo => Add an axios interceptor to handle token
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("auth_token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

//Todo => Add an axios interceptor to handle 401 unauthorized responses
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      logoutUser();
      window.location.href = "/signin";
    }
    return Promise.reject(error);
  }
);
